import { AppStoreType } from '@/types';

export const rollbackSubmissionPreparationText = (
    appStoreType: AppStoreType,
    isRollback: boolean,
    willBeSubmittedByRunway: boolean,
    disabledRollbackRequiredAutomationNames: string[] = [],
) => {
    if (!isRollback) {
        return undefined;
    }

    if (disabledRollbackRequiredAutomationNames.length > 0) {
        const automationNames = disabledRollbackRequiredAutomationNames.map((name) => `“${name}”`).join(', ');
        return `One or more automations that are required to submit a rollback build are disabled. Enable them to proceed with this rollback: ${automationNames}.`;
    }

    if (appStoreType === AppStoreType.Google) {
        return "When you confirm submission, Runway will ensure the draft production release exists, select the rollback APK/AAB, apply the source version's release notes when applicable, and submit the rollback to Google Play using the configured rollout settings. Google Play rollback submissions require manual confirmation and won't be submitted automatically.";
    }

    if (appStoreType === AppStoreType.Apple) {
        const timing =
            willBeSubmittedByRunway ?
                'Once the rollback build is available, the required steps are complete, and the rollback target release is live'
            :   'When you confirm submission';
        const submission = willBeSubmittedByRunway ? 'automatically submit' : 'submit';
        return `${timing}, Runway will ensure the App Store version exists, select the rollback build, apply the source version's release notes when applicable, and ${submission} it to App Review.`;
    }

    return undefined;
};
